import { render, staticRenderFns } from "./TabelaDePagamentosDeAprovarContasAPagar.vue?vue&type=template&id=2f07dbe8&scoped=true"
import script from "./TabelaDePagamentosDeAprovarContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDePagamentosDeAprovarContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDePagamentosDeAprovarContasAPagar.vue?vue&type=style&index=0&id=2f07dbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07dbe8",
  null
  
)

export default component.exports